import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { Menu as AntdMenu, Grid } from 'antd'
import IntlMessage from '../util-components/IntlMessage'
import Icon from '../util-components/Icon'
import navigationConfig from 'configs/NavigationConfig'
import { useSelector, useDispatch } from 'react-redux'
import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE } from 'constants/ThemeConstant'
import utils from 'utils'
import { onMobileNavToggle } from 'store/slices/themeSlice'
import styled from '@emotion/styled'
import jwtDecode from 'jwt-decode'

const { useBreakpoint } = Grid

const Menu = styled(AntdMenu)`
  li {
    width: 100% !important;
  }
`

const setLocale = (localeKey, isLocaleOn = true) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString()

const setDefaultOpen = key => {
  let keyList = []
  let keyString = ''
  if (key) {
    const arr = key.split('-')
    for (let index = 0; index < arr.length; index++) {
      const elm = arr[index]
      index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`)
      keyList.push(keyString)
    }
  }
  return keyList
}

const MenuItem = ({ title, icon, path }) => {
  const dispatch = useDispatch()

  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg')

  const closeMobileNav = () => {
    if (isMobile) {
      dispatch(onMobileNavToggle(false))
    }
  }

  return (
    <>
      {icon && <Icon type={icon} />}
      <span>{setLocale(title)}</span>
      {path && <Link onClick={closeMobileNav} to={path} />}
    </>
  )
}

const getSideNavMenuItem = (navItem, roles) =>
  navItem.map(nav => {
    if (
      nav.role &&
      nav.role.length > 0 &&
      roles &&
      !roles.find(role => nav.role.includes(role))
    ) {
      console.log({ left: nav.role, right: roles })
      return null
    }
    return {
      key: nav.key,
      label: (
        <MenuItem
          title={nav.title}
          {...(nav.isGroupTitle ? {} : { path: nav.path, icon: nav.icon })}
        />
      ),
      ...(nav.isGroupTitle ? { type: 'group' } : {}),
      ...(nav.submenu.length > 0
        ? { children: getSideNavMenuItem(nav.submenu, roles) }
        : {}),
    }
  })

const getTopNavMenuItem = (navItem, roles) =>
  navItem.map(nav => {
    return {
      key: nav.key,
      label: (
        <MenuItem
          title={nav.title}
          icon={nav.icon}
          {...(nav.isGroupTitle ? {} : { path: nav.path })}
        />
      ),
      ...(nav.submenu.length > 0
        ? { children: getTopNavMenuItem(nav.submenu, roles) }
        : {}),
    }
  })

const SideNavContent = props => {
  const {
    routeInfo,
    hideGroupTitle,
    sideNavTheme = SIDE_NAV_LIGHT,
    roles,
  } = props
  const menuItems = useMemo(
    () => getSideNavMenuItem(navigationConfig, roles),
    [roles]
  )

  return (
    <Menu
      mode="inline"
      theme={sideNavTheme === SIDE_NAV_LIGHT ? 'light' : 'dark'}
      style={{ height: '100%', borderInlineEnd: 'none' }}
      defaultSelectedKeys={[routeInfo?.key]}
      defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
      className={hideGroupTitle ? 'hide-group-title' : ''}
      items={menuItems}
    />
  )
}

const TopNavContent = ({ roles }) => {
  const topNavColor = useSelector(state => state.theme.topNavColor)

  const menuItems = useMemo(
    () => getTopNavMenuItem(navigationConfig, roles),
    [roles]
  )

  return (
    <Menu
      mode="horizontal"
      style={{ backgroundColor: topNavColor }}
      items={menuItems}
    />
  )
}

const MenuContent = props => {
  const { token } = useSelector(state => state.auth)
  const [roles, setRoles] = useState([])
  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token)
        setRoles(decoded.roles)
      } catch (error) {
        console.error('Error decoding JWT token:', error)
        setRoles([])
      }
    }
  }, [token])

  return props.type === NAV_TYPE_SIDE ? (
    <SideNavContent roles={roles} {...props} />
  ) : (
    <TopNavContent roles={roles} {...props} />
  )
}

export default MenuContent
